module.exports = __webpack_public_path__ + "img/bz.6c498be3.svg";